/**
 * @generated SignedSource<<00ae656782a42087803986394d18ef31>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type plainText_nativeIssueTable_PlainTextCell_fieldRef$data = {
  readonly id: string;
  readonly lazyIsEditableInIssueView?: boolean | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"singleLineText_issueFieldSingleLineTextInlineEditFull_SingleLineTextInlineEditViewWithIsEditable_fragmentRef">;
  readonly " $fragmentType": "plainText_nativeIssueTable_PlainTextCell_fieldRef";
};
export type plainText_nativeIssueTable_PlainTextCell_fieldRef$key = {
  readonly " $data"?: plainText_nativeIssueTable_PlainTextCell_fieldRef$data;
  readonly " $fragmentSpreads": FragmentRefs<"plainText_nativeIssueTable_PlainTextCell_fieldRef">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isInlineEditingEnabled"
    }
  ],
  "kind": "Fragment",
  "name": "plainText_nativeIssueTable_PlainTextCell_fieldRef",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "condition": "isInlineEditingEnabled",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "ClientExtension",
          "selections": [
            {
              "kind": "ScalarField",
              "name": "lazyIsEditableInIssueView"
            }
          ]
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "singleLineText_issueFieldSingleLineTextInlineEditFull_SingleLineTextInlineEditViewWithIsEditable_fragmentRef"
    }
  ],
  "type": "JiraSingleLineTextField"
};

(node as any).hash = "94479d3d1bc9c4154710d3e403b4d67d";

export default node;
